import { ThemeWrapper, useMobileLayout } from "@verity/components";
import BackButton from "../../../components/back-button";
import VisualizerBanner from "../visualizer-banner";
import EditVerityAssessmentSection from "../assessments-page/verity-assessment/EditVerityAssessmentSection";
import { QuizWithProctoringOptions } from "../assessments-page/assessments-page-helper";
import i18n from "../../../i18n";
import styles from "./index.module.css";

export default function EditAssessmentPage({
	assessment,
	onFinish,
}: {
	assessment: QuizWithProctoringOptions;
	onFinish: () => void;
}) {
	const isMobileLayout = useMobileLayout();

	return (
		<ThemeWrapper scopedCssBaselineProps={{ className: styles.page }}>
			<div className={styles.pageContainer}>
				<VisualizerBanner />
				{!isMobileLayout && (
					<div>
						<BackButton
							variant="cancel"
							onBack={onFinish}
							ariaLabel={i18n.t("portal.components.createAssessmentPageTSX.backButtonAriaLabel")}
						/>
					</div>
				)}
				<EditVerityAssessmentSection assessment={assessment} onFinish={onFinish} />
			</div>
		</ThemeWrapper>
	);
}
